import { AxiosClient, AxiosToken } from '../config/axios'

/**
 * This method is used to connect with backend and send email informing that someone shared a document
 * @param {Number} user_id
 * @param {Array} emails
 * @return {Void}
*/
export const sendShareDocumentEmail = async (user_id: any, emails: any[]): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.post('/email/share-document', {user_id, emails})
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and send email informing that someone edited document
 * @param {String} editor_email
 * @param {String} creator_email
 * @param {Array} changes
 * @return {Void}
*/
export const sendEditDocumentEmail = async (editor_email: any, creator_email: any, changes: any[]): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.post('/email/edited', {editor_email, creator_email, changes})
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and send email informing that someone signed  document
 * @param {String} sign_email
 * @param {String} creator_email
 * @return {Void}
*/
export const sendSignDocumentEmail = async (sign_email: any, creator_email: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.post('/email/sign', {sign_email, creator_email})
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}